// extracted by mini-css-extract-plugin
var _1 = "styles-module__contributeButton___L2ssC";
export { _1 as "contributeButton" }
